import React from 'react'
import AceEditor from "react-ace";

function SSOEditor({ value, handleChange }: { value: Record<string, any>, handleChange: (newValues: Record<string, any>) => void }) {

  const onChange = (val: string) => {
    handleChange(JSON.parse(val));
  }


  return (
    <AceEditor
      mode="javascript"
      theme="monokai"
      name="blah2"
      onChange={onChange}
      fontSize={14}
      showPrintMargin={true}
      showGutter={true}
      height='400px'
      highlightActiveLine={true}
      value={JSON.stringify(value, null, '\t')}
      setOptions={{
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        enableSnippets: false,
        showLineNumbers: true,
        tabSize: 4,
      }} />

  )
}

export default SSOEditor